import { APICode } from '@/constants';
import type { TCollectOption, TTaskOptions } from '@/types';
import axios from 'axios';

const axiosInstance = axios.create({
  timeout: 60000,
  withCredentials: true,
  baseURL: process.env.REACT_APP_BASE_URL,
})

axiosInstance.interceptors.request.use(
  (config: any) => {
    config.headers["x-app-id"] = "app-fotor-web";
    config.headers['Content-Type'] = config.headers['Content-Type']
        ? config.headers['Content-Type']
        : 'application/x-www-form-urlencoded';
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export const getCredits = () => {
  return axiosInstance
    .get(`/api/create/getScore`, {})
    .then(res => {
      return res.data
    })
}

export const getSubscriptions = () => {
  return axiosInstance
    .get(`/api/app/payment/subscriptions`, {})
    .then(res => {
      return res.data
    })
}

export const getLoginState = () => {
  return axiosInstance
    .get(`/User/GetLoginState`, {})
    .then(res => {
      return res.data
    })
}

export const getPresetExpTempList = (limit: number = 100) => {
  const url = `/api/aigc/video/live-portrait/styles?limit=${limit}`;
  return axiosInstance
    .get(url, {})
    .then(res => {
      return res.data
    })
}

export const getSignUrl = (extension: string = 'jpg') => {
  return axiosInstance
    .post(
      "/api/resource/images/uploader/commonSign", 
      {
        extension,
        type: "liveportrait"
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(res => {
      return res.data;
    });
};

export const putFileTo = (file: File, url: string, onProgress?: (value: any) => void) => {  
  return axios({
    method: 'PUT',
    url,
    data: file,
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: onProgress,
    withCredentials: false,
  }).then((res: any) => {
    if (res?.status === 200) {
      return { code: APICode.Success };
    } else {
      throw new Error();
    }
  })
}

export const postTask = (data: TTaskOptions) => {
  return axiosInstance
    .post(
      `/api/aigc/video/live-portrait`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(res => {
      return res.data
    })
}

export const getTask = (taskId: string) => {
  const url = `/api/aigc/video/live-portrait/${taskId}`;
  return axiosInstance
    .get(url, {})
    .then(res => {
      return res.data
    })
}

export async function getFileByUrl(url: string) {
  return axios({
    url,
    method: "GET",
    responseType: "blob",
  }).then((res) => {
    return new File([res.data], url, {
      type: res.data.type,
    });
  });
}

export const postCollect = (data: TCollectOption) => {
  return axiosInstance
    .post(
      "/api/create/collection_tasks",
      data,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    )
    .then(res => res.data);
}

export const setHistoryTool = (toolId: string) => {
  return axiosInstance
    .put(
      `/api/user-profile/v1/tool`,
      { toolId },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(res => {
      return res.data;
    });
};